import api from '../api'

export default {
  getHomeCakeList (data, successCallback, errCallback = function () {}, isShowErrMsg = true) {
    api.get('api/appclient/v2/product/index', data, successCallback, errCallback, isShowErrMsg)
  },
  getBanner (data, successCallback, errCallback = function () {}, isShowErrMsg = true) {
    api.get('api/appclient/v2/cms/banner', data, successCallback, errCallback, isShowErrMsg)
  },
  getCityClosing (data, successCallback, errCallback = function () {}, isShowErrMsg = true) {
    api.post('api/front/v2/baseinfo/cityCutOrder/queryCityClosingConfigDesc', data, successCallback, errCallback, isShowErrMsg)
    // api.get('api/appclient/v2/baseinfo/cityClosing', data, successCallback, errCallback, isShowErrMsg)
  }
}



// WEBPACK FOOTER //
// ./src/api/home/api.home.js